import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
// import history from '../../../../../commons/history';
import LayoutAction from '../../../../../modules/actions/LayoutAction';
import { MASTERIMAGES } from '../../../../../commons/api';

const LeftSidePanel = (props) => {
  const navigate = useNavigate();
   const { LayoutAction } = props;

  const craneList = [
    {
      title: 'ECH',
      redirectURL: '/rubus/dashboard/ECH',
      image: `${MASTERIMAGES.ECH_PNG}`,
      redirectMenu: ['Modules', '51228', '51234']
    },
    {
      title: 'Reach Stacker',
      image: `${MASTERIMAGES.RS_PNG}`,
      redirectURL: '/rubus/dashboard/RSS',
      redirectMenu: ['Modules', '51228', '51236']
    },
    {
      title: 'ITV',
      image: `${MASTERIMAGES.ITV_PNG}`,
      redirectURL: '/rubus/dashboard/ITV',
      redirectMenu: ['Modules', '51228', '51238']
    },
    {
      title: 'GIS Tracking',
      image: `${MASTERIMAGES.GISTRACKING_PNG}`
    },
    {
      title: 'MHC',
      image: `${MASTERIMAGES.ST_MHC_V1_PNG}`,
      redirectURL: '/rubus/HMI/static/MHC',
      redirectMenu: ['Modules', '51228', '51268']
    },
    {
      title: 'QC',
      image: `${MASTERIMAGES.ST_QC_V1_PNG}`,
      redirectURL: '/rubus/HMI/static/QC',
      redirectMenu: ['Modules', '51228', '51242']
    },
    {
      title: 'RTG',
      image: `${MASTERIMAGES.ST_RTG_V1_PNG}`,
      redirectURL: '/rubus/HMI/static/RTG',
      redirectMenu: ['Modules', '51228', '51256']
    }
  ];

  return (
    <>
      {craneList && Array.isArray(craneList) && craneList.map((crane, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
          <img
            style={{ cursor: crane.redirectURL ? 'pointer' : 'default' }}
            height="60"
            width="60"
            onClick={() => {
              if (crane.redirectURL) {
                LayoutAction.setMenuSelection(crane.redirectMenu);
                navigate(crane.redirectURL);
              }
            }}
            src={crane.image}
            alt={crane.title}
          />
          <div>{crane.title}</div>
        </div>
      ))}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
      LayoutAction: bindActionCreators(LayoutAction, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(LeftSidePanel);

